export default "__VITE_PUBLIC_ASSET__2dff5594__"